import { ReactComponent as Icon } from "../assets/icons/chats/Info.svg";
import genIcons from "./genIcons";

const Info = { Outline: genIcons(Icon, { htmlColor: "transparent" }) };

export default Info;
